export enum FormLayoutModifier {
	BLUE_BACKGROUND = 'BLUE_BACKGROUND'
}
